export default __webpack_public_path__ + "fonts/iconfont.920b99f90bf9f955b1bc39edb969d63f.woff";